// import { useEffect, useState } from "react";
// import "./Interest.css";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   acceptInterest,
//   fetchUserInterests,
//   declineInterest,
// } from "../redux/interestSlice";
// import { useNavigate } from "react-router-dom";
// import userAvatar from "../img/user-avatar.png";

// import IMG11 from "../img/SSimg1.png";

// // ─── Mock Data (replace with MongoDB API calls) ───────────────────────────────

// const receivedData = [
//   {
//     id: 1,
//     name: "Kavya Rajan",
//     age: 26,
//     location: "Coimbatore, TN",
//     job: "Software Engineer",
//     bio: "Loves classical music, trekking, and good filter coffee.",
//     match: 94,
//     time: "2 hours ago",
//   },
//   {
//     id: 2,
//     name: "Kavya Rajan",
//     age: 26,
//     location: "Coimbatore, TN",
//     job: "Software Engineer",
//     bio: "Loves classical music, trekking, and good filter coffee.",
//     match: 94,
//     time: "2 hours ago",
//   },
//   {
//     id: 3,
//     name: "Kavya Rajan",
//     age: 26,
//     location: "Coimbatore, TN",
//     job: "Software Engineer",
//     bio: "Loves classical music, trekking, and good filter coffee.",
//     match: 94,
//     time: "2 hours ago",
//   },
//   {
//     id: 4,
//     name: "Kavya Rajan",
//     age: 26,
//     location: "Coimbatore, TN",
//     job: "Software Engineer",
//     bio: "Loves classical music, trekking, and good filter coffee.",
//     match: 94,
//     time: "2 hours ago",
//   },
// ];

// const sentData = [
//   {
//     id: 1,
//     name: "Deepa Krishnan",
//     age: 25,
//     location: "Trichy, TN",
//     job: "Architect",
//     bio: "Loves classical music, trekking, and good filter coffee.",
//     status: "viewed",
//   },
//   {
//     id: 2,
//     name: "Lavanya Balaji",
//     age: 27,
//     location: "Chennai, TN",
//     job: "HR Manager",
//     bio: "Loves classical music, trekking, and good filter coffee.",
//     status: "pending",
//   },
//   {
//     id: 3,
//     name: "Shreya Mohan",
//     age: 26,
//     location: "Bengaluru, KA",
//     job: "Data Scientist",
//     bio: "Loves classical music, trekking, and good filter coffee.",
//     status: "accepted",
//   },
//   {
//     id: 4,
//     name: "Nithya Subramanian",
//     age: 28,
//     location: "Coimbatore, TN",
//     job: "Pharmacist",
//     bio: "Loves classical music, trekking, and good filter coffee.",
//     status: "pending",
//   },
// ];

// const acceptedData = [
//   {
//     id: 1,
//     name: "Shreya Mohan",
//     age: 26,
//     location: "Bengaluru, KA",
//     job: "Data Scientist",
//     connectedAgo: "2 days ago",
//   },
//   {
//     id: 2,
//     name: "Rima Das",
//     age: 27,
//     location: "Coimbatore, TN",
//     job: "Lawyer",
//     connectedAgo: "5 days ago",
//   },
//   {
//     id: 3,
//     name: "Vandana Rao",
//     age: 25,
//     location: "Mysuru, KA",
//     job: "Dentist",
//     connectedAgo: "1 week ago",
//   },
// ];

// const declinedData = [
//   {
//     id: 1,
//     name: "Shreya Mohan",
//     age: 26,
//     location: "Bengaluru, KA",
//     job: "Data Scientist",
//     connectedAgo: "2 days ago",
//   },
//   {
//     id: 2,
//     name: "Rima Das",
//     age: 27,
//     location: "Coimbatore, TN",
//     job: "Lawyer",
//     connectedAgo: "5 days ago",
//   },
//   {
//     id: 3,
//     name: "Vandana Rao",
//     age: 25,
//     location: "Mysuru, KA",
//     job: "Dentist",
//     connectedAgo: "1 week ago",
//   },
// ];

// // ─── Tab Config ───────────────────────────────────────────────────────────────

// // const tabs = [
// //   { key: "received", label: "Received", count: 12 },
// //   { key: "sent", label: "Sent", count: 7 },
// //   { key: "accepted", label: "Accepted", count: 3 },
// //   { key: "declined", label: "Declined", count: 5 },
// // ];

// // ─── Received Section ─────────────────────────────────────────────────────────


// //

// function ReceivedSection({ received, acceptRequest, declineRequest }) {
//   const navigate = useNavigate();
//   console.log("ReceivedSection:", received);

//   return (
//     <div className="content-area">
//       <div className="sort-row">
//         <span className="section-title">
//           {received.length || 0} new interests
//         </span>
//         <button className="sort-btn">Sort by match ↓</button>
//       </div>

//       <div className="received-grid">
//         {received.map((p) => {
//           const fromProfile = p.fromProfile || {}; // Adjust based on actual data structure
//           const profileURL = fromProfile?.photos?.find(
//             (photo) => photo.isPrimary,
//           );
//           console.log("Profile URL:", profileURL);

//           const imageUrl = profileURL?.url
//             ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${profileURL?.url}`
//             : userAvatar || "/default-avatar.png";
//           const location = [
//             fromProfile.location?.city,
//             fromProfile.location?.state,
//             fromProfile.location?.country,
//           ]
//             .filter(Boolean)
//             .join(", ");
//           return (
//             <div className="interest-card" key={p._id}>
//               <div className="card-top">
//                 <div className="card-photo-wrap">
//                   <img src={imageUrl} alt={p.name} className="card-photo" />
//                   <span className="interested-badge">Interested in you</span>
//                   <span className="match-badge1">
//                     {p.matchPercentage}% match
//                   </span>
//                 </div>

//                 <div className="card-info">
//                   <div className="card-time-row">
//                     <span className="card-time">{p.timeAgo}</span>
//                   </div>
//                   <div className="card-name1">{fromProfile.fullName}</div>
//                   <div className="card-meta">
//                     {fromProfile.age} yrs · {location}
//                   </div>
//                   <div className="card-job">{fromProfile.profession}</div>
//                   <div className="card-bio">{fromProfile.aboutMe}</div>
//                 </div>
//               </div>

//               <div className="card-actions1">
//                 <button
//                   className="action-btn"
//                   onClick={() => navigate(`/profile/${fromProfile._id}`)}
//                 >
//                   View profile
//                 </button>
//                 <button
//                   className="icon-btn1"
//                   onClick={() => acceptRequest(p._id)}
//                 >
//                   ✓
//                 </button>
//                 <button
//                   className="icon-btn1"
//                   onClick={() => declineRequest(p._id)}
//                 >
//                   ✕
//                 </button>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

// // ─── Sent Section ─────────────────────────────────────────────────────────────

// function SentSection({ sent }) {
//   console.log("SentSection:", sent);

//   const statusLabel = {
//     viewed: "Viewed",
//     pending: "Pending",
//     accepted: "Accepted",
//   };

//   return (
//     <div className="content-area">
//       <div className="section-title">Interests you sent</div>
//       {sent.length === 0 && (
//         <p className="no-connections">No interest requests sent yet.</p>
//       )}
//       {sent.map((p) => {
//         const toProfile = p.toProfile || {}; // Adjust based on actual data structure
//         const profileURL = toProfile?.photos?.find((photo) => photo.isPrimary);
//         console.log("send Profile URL:", profileURL);

//         const imageUrl = profileURL?.url
//           ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${profileURL?.url}`
//           : userAvatar || "/default-avatar.png";
//         const location = [
//           toProfile.location?.city,
//           toProfile.location?.state,
//           toProfile.location?.country,
//         ]
//           .filter(Boolean)
//           .join(", ");
//         return (
//           <div className="profile-card1" key={p._id}>
//             <img src={imageUrl} alt={p.name} className="profile-photo" />
//             <div className="profile-info">
//               <div className="profile-name">{toProfile.fullName}</div>
//               <div className="profile-meta">
//                 {toProfile.age} yrs · {location}
//               </div>
//               <div className="profile-job">{toProfile.profession}</div>
//               <div className="profile-bio">{toProfile.aboutMe}</div>
//             </div>

//             <span className={`status-badge ${p.status}`}>
//               {statusLabel[p.status]}
//             </span>
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// // ─── Accepted Section ─────────────────────────────────────────────────────────

// function AcceptedSection({ accepted }) {
//   const [selectedUser, setSelectedUser] = useState(null);
//   return (
//     <div className="content-area">
//       <div className="section-title2">Mutual connections</div>
//       {accepted.length === 0 && (
//         <p className="no-connections">
//           No accepted interests yet. Start connecting!
//         </p>
//       )}
//       {accepted.map((p) => {
//         const fromProfile = p.fromProfile || {}; // Adjust based on actual data structure
//         const profileURL = fromProfile?.photos?.find(
//           (photo) => photo.isPrimary,
//         );
//         console.log("Profile URL:", profileURL);

//         const imageUrl = profileURL?.url
//           ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${profileURL?.url}`
//           : userAvatar || "/default-avatar.png";
//         const location = [
//           fromProfile.location?.city,
//           fromProfile.location?.state,
//           fromProfile.location?.country,
//         ]
//           .filter(Boolean)
//           .join(", ");
//         return (
//           <div className="profile-card1" key={p.id}>
//             <img src={imageUrl} alt={p.name} className="profile-photo" />
//             <div className="profile-info">
//               <div className="profile-name">{fromProfile.fullName}</div>
//               <div className="profile-meta">
//                 {fromProfile.age} yrs · {location}
//               </div>
//               <div className="profile-job">{fromProfile.profession}</div>
//               <div className="profile-time">Connected {p.timeAgo}</div>
//             </div>

//             <button className="action-btn" onClick={() => setSelectedUser(p)}>
//               Chat
//             </button>
//           </div>
//         );
//       })}
//       <ChatModal
//         isOpen={!!selectedUser}
//         user={selectedUser}
//         onClose={() => setSelectedUser(null)}
//       />
//     </div>
//   );
// }
// // ─── Declined Section ─────────────────────────────────────────────────────────

// function DeclinedSection({ declined }) {
//   console.log("DeclinedSection:", declined);

//   return (
//     <div className="content-area">
//       <div className="section-title">Mutual connections</div>
//       {declined.length === 0 && (
//         <p className="no-connections">No declined interests yet.</p>
//       )}
//       {declined.map((p) => {
//         const fromProfile = p.fromProfile || {}; // Adjust based on actual data structure
//         const profileURL = fromProfile?.photos?.find(
//           (photo) => photo.isPrimary,
//         );
//         console.log("Profile URL:", profileURL);

//         const imageUrl = profileURL?.url
//           ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${profileURL?.url}`
//           : userAvatar || "/default-avatar.png";
//         const location = [
//           fromProfile.location?.city,
//           fromProfile.location?.state,
//           fromProfile.location?.country,
//         ]
//           .filter(Boolean)
//           .join(", ");
//         return (
//           <div className="profile-card1" key={p.id}>
//             <img
//               src={imageUrl}
//               alt={fromProfile.fullName}
//               className="profile-photo"
//             />
//             <div className="profile-info">
//               <div className="profile-name">{fromProfile.fullName}</div>
//               <div className="profile-meta">
//                 {fromProfile.age} yrs · {location}
//               </div>
//               <div className="profile-job">{fromProfile.profession}</div>
//               <div className="profile-time">Connected {p.timeAgo}</div>
//             </div>

//             {/* <button className="action-btn">Undo</button> */}
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// // chat

// function ChatModal({ isOpen, onClose, user }) {
//   const [show, setShow] = useState(false);
//   const [messages, setMessages] = useState([
//     { text: "Hey there!", sender: "other" },
//     { text: "Hi! How are you?", sender: "me" },
//   ]);
//   const [input, setInput] = useState("");

//   useEffect(() => {
//     if (isOpen) {
//       setShow(true);
//     } else {
//       setTimeout(() => setShow(false), 300); // match animation duration
//     }
//   }, [isOpen]);

//   const sendMessage = () => {
//     if (!input.trim()) return;

//     setMessages([...messages, { text: input, sender: "me" }]);
//     setInput("");
//   };

//   if (!show) return null;

//   return (
//     <div className={`chat-overlay ${isOpen ? "open" : "close"}`}>
//       <div className={`chat-modal ${isOpen ? "slide-up" : "slide-down"}`}>
//         {/* HEADER */}
//         <div className="chat-header">
//           <div className="chat-user">
//             <img src={IMG11} alt={user?.name} />

//             <div className="chat-user-info">
//               <div className="chat-user-name">{user?.name}</div>
//               <div className="chat-user-status">Active now</div>
//             </div>
//           </div>

//           <button onClick={onClose}>✕</button>
//         </div>

//         {/* BODY */}
//         <div className="chat-body">
//           {messages.map((msg, i) => (
//             <div
//               key={i}
//               className={`chat-bubble ${
//                 msg.sender === "me" ? "right" : "left"
//               }`}
//             >
//               {msg.text}
//             </div>
//           ))}
//         </div>

//         {/* INPUT */}
//         <div className="chat-input">
//           <input
//             value={input}
//             onChange={(e) => setInput(e.target.value)}
//             placeholder="Type a message..."
//           />
//           <button onClick={sendMessage}>Send</button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ─── Main Component ───────────────────────────────────────────────────────────

// export default function InterestPage() {
//   const [active, setActive] = useState("received");
//   const [animKey, setAnimKey] = useState(0);
//   const [counts, setCounts] = useState();
//   const [receivedInterests, setReceivedInterests] = useState([]);
//   const [sentInterests, setSentInterests] = useState([]);
//   const [acceptedInterests, setAcceptedInterests] = useState([]);
//   const [declinedInterests, setDeclinedInterests] = useState([]);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const interests = useSelector((state) => state.interests.data);

//   useEffect(() => {
//     // Dispatch action to fetch interest stats from MongoDB API
//     dispatch(fetchUserInterests());
//   }, [dispatch]);

//   useEffect(() => {
//     console.log("Fetched interests from store:", interests);
//     // Here you would update the `tabs` counts based on the fetched data
//     let counts = interests?.counts;
//     const tabs = [
//       { key: "received", label: "Received", count: counts?.received || 0 },
//       { key: "sent", label: "Sent", count: counts?.sent || 0 },
//       { key: "accepted", label: "Accepted", count: counts?.accepted || 0 },
//       { key: "declined", label: "Declined", count: counts?.rejected || 0 },
//     ];
//     setCounts(tabs);
//   }, [interests]);

//   // recived intrest set
//   useEffect(() => {
//     console.log("Fetched interests from store:", interests);
//     // Here you would update the `tabs` counts based on the fetched data
//     let data = interests?.data;
//     if (data?.received) {
//       setReceivedInterests(data.received);
//     }
//     if (data?.sent) {
//       setSentInterests(data.sent);
//     }
//     if (data?.accepted) {
//       setAcceptedInterests(data.accepted);
//     }
//     if (data?.rejected) {
//       setDeclinedInterests(data.rejected);
//     }
//   }, [interests]);

//   // recived intrest set
//   useEffect(() => {
//     console.log("Fetched interests from store:", interests);
//     // Here you would update the `tabs` counts based on the fetched data
//     let data = interests?.data;
//     if (data?.received) {
//       setReceivedInterests(data.received);
//     }
//   }, [interests]);

//   const handleTabChange = (key) => {
//     if (key !== active) {
//       setActive(key);
//       setAnimKey((prev) => prev + 1); // re-triggers fade animation on switch
//     }
//   };

//   const renderSection = ({ acceptRequest, declineRequest }) => {
//     switch (active) {
//       case "received":
//         return (
//           <ReceivedSection
//             received={receivedInterests}
//             acceptRequest={acceptRequest}
//             declineRequest={declineRequest}
//           />
//         );
//       case "sent":
//         return <SentSection sent={sentInterests} />;
//       case "accepted":
//         return <AcceptedSection accepted={acceptedInterests} />;
//       case "declined":
//         return <DeclinedSection declined={declinedInterests} />;
//       default:
//         return null;
//     }
//   };

//   //Accept request
//   const acceptRequest = (id) => {
//     console.log("Accepting request with id:", id);
//     dispatch(acceptInterest(id));
//   };

//   //Decline request
//   const declineRequest = (id) => {
//     console.log("Declining request with id:", id);
//     dispatch(declineInterest(id));
//   };

//   return (
//     <div className="interest-page">
//       {/* ── Stats / Tab Switcher ── */}
//       <div className="stats-row1">
//         {counts?.map((tab) => (
//           <div
//             key={tab.key}
//             className={`stat-card ${active === tab.key ? "active" : ""}`}
//             onClick={() => handleTabChange(tab.key)}
//           >
//             <div className="stat-num">{tab.count}</div>
//             <div className="stat-label">{tab.label}</div>
//           </div>
//         ))}
//       </div>

//       <div className="divider" />

//       {/* ── Tab Content — key prop re-triggers animation on every tab switch ── */}
//       <div key={animKey}>
//         {renderSection({ acceptRequest, declineRequest })}
//       </div>
//     </div>
//   );
// }


// import { useEffect, useRef, useState } from "react";
// import "./Interest.css";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   acceptInterest,
//   fetchUserInterests,
//   declineInterest,
// } from "../redux/interestSlice";
// import { useNavigate } from "react-router-dom";
// import userAvatar from "../img/user-avatar.png";
// import IMG11 from "../img/SSimg1.png";
// import { createConversation, sendChatMessage ,getMessages} from "../services/chatService";
// import { io } from "socket.io-client";

// // ─── Socket singleton ─────────────────────────────────────────────────────────

// let socket = null;

// const getSocket = () => {
//   if (!socket || !socket.connected) {
//     socket = io(process.env.REACT_APP_SOCKET_URL || "http://localhost:5000", {
//       auth: { token: localStorage.getItem("token") },
//       transports: ["websocket"],
//     });
//     socket.on("connect", () => console.log("✅ Socket connected:", socket.id));
//     socket.on("disconnect", () => console.log("❌ Socket disconnected"));
//   }
//   return socket;
// };

// // ─── Received Section ─────────────────────────────────────────────────────────

// function ReceivedSection({ received, acceptRequest, declineRequest }) {
//   const navigate = useNavigate();

//   return (
//     <div className="content-area">
//       <div className="sort-row">
//         <span className="section-title">
//           {received.length || 0} new interests
//         </span>
//         <button className="sort-btn">Sort by match ↓</button>
//       </div>

//       <div className="received-grid">
//         {received.map((p) => {
//           const fromProfile = p.fromProfile || {};
//           const profileURL = fromProfile?.photos?.find(
//             (photo) => photo.isPrimary
//           );
//           const imageUrl = profileURL?.url
//             ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${profileURL?.url}`
//             : userAvatar || "/default-avatar.png";
//           const location = [
//             fromProfile.location?.city,
//             fromProfile.location?.state,
//             fromProfile.location?.country,
//           ]
//             .filter(Boolean)
//             .join(", ");

//           return (
//             <div className="interest-card" key={p._id}>
//               <div className="card-top">
//                 <div className="card-photo-wrap">
//                   <img 
//                     src={imageUrl} 
//                     alt={p.name} 
//                     className="card-photo" 
//                     onError={(e) => {
//                       e.target.onerror = null;
//                       e.target.src = userAvatar;
//                     }} />
//                   <span className="interested-badge">Interested in you</span>
//                   <span className="match-badge1">
//                     {p.matchPercentage}% match
//                   </span>
//                 </div>
//                 <div className="card-info">
//                   <div className="card-time-row">
//                     <span className="card-time">{p.timeAgo}</span>
//                   </div>
//                   <div className="card-name1">{fromProfile.fullName}</div>
//                   <div className="card-meta">
//                     {fromProfile.age} yrs · {location}
//                   </div>
//                   <div className="card-job">{fromProfile.profession}</div>
//                   <div className="card-bio">{fromProfile.aboutMe}</div>
//                 </div>
//               </div>
//               <div className="card-actions1">
//                 <button
//                   className="action-btn"
//                   onClick={() => navigate(`/profile/${fromProfile._id}`)}
//                 >
//                   View profile
//                 </button>
//                 <button
//                   className="icon-btn1"
//                   onClick={() => acceptRequest(p._id)}
//                 >
//                   ✓
//                 </button>
//                 <button
//                   className="icon-btn1"
//                   onClick={() => declineRequest(p._id)}
//                 >
//                   ✕
//                 </button>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

// // ─── Sent Section ─────────────────────────────────────────────────────────────

// function SentSection({ sent }) {
//   const statusLabel = {
//     viewed: "Viewed",
//     pending: "Pending",
//     accepted: "Accepted",
//   };

//   return (
//     <div className="content-area">
//       <div className="section-title">Interests you sent</div>
//       {sent.length === 0 && (
//         <p className="no-connections">No interest requests sent yet.</p>
//       )}
//       {sent.map((p) => {
//         const toProfile = p.toProfile || {};
//         const profileURL = toProfile?.photos?.find((photo) => photo.isPrimary);
//         const imageUrl = profileURL?.url
//           ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${profileURL?.url}`
//           : userAvatar || "/default-avatar.png";
//         const location = [
//           toProfile.location?.city,
//           toProfile.location?.state,
//           toProfile.location?.country,
//         ]
//           .filter(Boolean)
//           .join(", ");

//         return (
//           <div className="profile-card1" key={p._id}>
//             <img 
//               src={imageUrl} 
//               alt={p.name} 
//               className="profile-photo" 
//               onError={(e)=>{
//                 e.target.onerror = null;
//                 e.target.src = userAvatar;
//               }}/>
//             <div className="profile-info">
//               <div className="profile-name">{toProfile.fullName ? toProfile.fullName : toProfile?.firstName ? toProfile.firstName + " " + (toProfile.lastName || "") : "Name not available"}</div>
//               <div className="profile-meta">
//                 {toProfile.age} yrs · {location}
//               </div>
//               <div className="profile-job">{toProfile.profession}</div>
//               <div className="profile-bio">{toProfile.aboutMe}</div>
//             </div>
//             <span className={`status-badge ${p.status}`}>
//               {statusLabel[p.status]}
//             </span>
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// // ─── Accepted Section ─────────────────────────────────────────────────────────

// function AcceptedSection({ accepted, setToast }) {
//   const [selectedUser, setSelectedUser] = useState(null);

// //check payment status and open chat
// const checkPaymentStatusAndChat = (p) => {
//   const user = localStorage.getItem("user");
//   const userFromStorage = JSON.parse(user); 
//   setSelectedUser(p);
//   // if(userFromStorage?.paymentStatus === "SUCCESS") {
//   //   setSelectedUser(p);
//   // } else {
//   //   showToast("Please upgrade your plan to message this user.", "error");
//   //   // alert("Please complete the payment to start chatting.");
//   // }
// }


//   return (
//     <div className="content-area">
//       <div className="section-title2">Mutual connections</div>
//       {accepted.length === 0 && (
//         <p className="no-connections">
//           No accepted interests yet. Start connecting!
//         </p>
//       )}
//       {accepted.map((p) => {
//         let toProfile =  {};
//         let user = localStorage.getItem('user');
//         let userObj = user ? JSON.parse(user) : null;
//         let userId = userObj?.id || null;
// console.log(userId);
//         if(p.fromProfile?.userId === userId){
//           toProfile = p.toProfile || {};
//         }

//         if(p.toProfile?.userId === userId){
//           toProfile = p.fromProfile || {};
//         }

//         console.log('toProfileshow:', toProfile);
        
//         const profileURL = toProfile?.photos?.find(
//           (photo) => photo.isPrimary
//         );
//         const imageUrl = profileURL?.url
//           ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${profileURL?.url}`
//           : userAvatar || "/default-avatar.png";
//         const location = [
//           toProfile.location?.city,
//           toProfile.location?.state,
//           toProfile.location?.country,
//         ]
//           .filter(Boolean)
//           .join(", ");

//         return (
//           <div className="profile-card1" key={p._id}>
//             <img
//               src={imageUrl}
//               alt={toProfile.fullName || toProfile.firstName}
//               className="profile-photo"
//               onError={(e) => {
//                 e.target.onerror = null;
//                 e.target.src = userAvatar;
//               }}
//             />
//             <div className="profile-info">
//               <div className="profile-name">{toProfile.fullName || toProfile.firstName + " " + (toProfile.lastName || "")}</div>
//               <div className="profile-meta">
//                 {toProfile.age} yrs · {location}
//               </div>
//               <div className="profile-job">{toProfile.profession}</div>
//               <div className="profile-time">Connected {p.timeAgo}</div>
//             </div>
//             <button
//               className="action-btn"
//               onClick={() => checkPaymentStatusAndChat(p)}
//             >
//               Chat
//             </button>
//           </div>
//         );
//       })}
//       <ChatModal
//         isOpen={!!selectedUser}
//         user={selectedUser}
//         onClose={() => setSelectedUser(null)}
//       />
//     </div>
//   );
// }

// // ─── Declined Section ─────────────────────────────────────────────────────────

// function DeclinedSection({ declined }) {
//   return (
//     <div className="content-area">
//       <div className="section-title">Declined interests</div>
//       {declined.length === 0 && (
//         <p className="no-connections">No declined interests yet.</p>
//       )}
//       {declined.map((p) => {
//         let user = localStorage.getItem('user');
//         let userObj = user ? JSON.parse(user) : null;
//         let userId = userObj?.id || null;
//         let toProfile = p.toProfile || {};
//         if(p.fromProfile?.userId === userId){
//           toProfile = p.toProfile || {};
//         }

//         if(p.toProfile?.userId === userId){
//           toProfile = p.fromProfile || {};
//         }
//         const profileURL = toProfile?.photos?.find(
//           (photo) => photo.isPrimary
//         );
//         const imageUrl = profileURL?.url
//           ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${profileURL?.url}`
//           : userAvatar || "/default-avatar.png";
//         const location = [
//           toProfile.location?.city,
//           toProfile.location?.state,
//           toProfile.location?.country,
//         ]
//           .filter(Boolean)
//           .join(", ");

//         return (
//           <div className="profile-card1" key={p._id}>
//             <img
//               src={imageUrl}
//               alt={toProfile.fullName || toProfile.firstName + " " + (toProfile.lastName || "")}
//               className="profile-photo"
//               onError={(e) => {
//                 e.target.onerror = null;
//                 e.target.src = userAvatar;
//               }}
//             />
//             <div className="profile-info">
//               <div className="profile-name">{toProfile.fullName || toProfile.firstName + " " + (toProfile.lastName || "")}</div>
//               <div className="profile-meta">
//                 {toProfile.age} yrs · {location}
//               </div>
//               <div className="profile-job">{toProfile.profession}</div>
//               <div className="profile-time">Connected {p.timeAgo}</div>
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// // ─── Chat Modal ───────────────────────────────────────────────────────────────

// function ChatModal({ isOpen, onClose, user }) {
//   const [show, setShow] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [input, setInput] = useState("");
//   const [conversationId, setConversationId] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const chatBodyRef = useRef(null);
//   const convIdRef = useRef(null);

//   // ✅ Auto scroll
//   useEffect(() => {
//     if (chatBodyRef.current) {
//       chatBodyRef.current.scrollTop =
//         chatBodyRef.current.scrollHeight;
//     }
//   }, [messages]);

//   // ✅ Open / Close modal
//   useEffect(() => {
//     if (isOpen) {
//       setShow(true);
//       initConversation();
//     } else {
//       const s = getSocket();

//       if (convIdRef.current) {
//         s.emit("leaveRoom", convIdRef.current);
//         console.log("✅ Left room:", convIdRef.current);
//       }

//       setTimeout(() => {
//         setShow(false);
//         setMessages([]);
//         setConversationId(null);
//         convIdRef.current = null;
//       }, 300);
//     }
//   }, [isOpen]);

//   // ✅ ✅ SOCKET LISTENER (MAIN FIX)
//   useEffect(() => {
//     if (!conversationId) return;

//     const s = getSocket();

//     const handleMessage = (message) => {
//       const myProfileId = localStorage.getItem("profileId");

//       console.log("📩 Socket message:", message);

//       // ❗ Ignore my own messages (prevents duplicate)
//       if (message.sender === myProfileId) return;

//       setMessages((prev) => [
//         ...prev,
//         {
//           text: message.text,
//           sender: "other",
//         },
//       ]);
//     };

//     s.on("receiveMessage", handleMessage);

//     return () => {
//       // ✅ Remove only this listener
//       s.off("receiveMessage", handleMessage);
//     };
//   }, [conversationId]);

//   // ✅ INIT CONVERSATION (NO SOCKET LISTENER HERE)
//   // const initConversation = async () => {
//   //   if (!user) return;

//   //   const toProfileId =
//   //     user.fromProfile?._id ||
//   //     user.toProfile?._id ||
//   //     user._id;

//   //   if (!toProfileId) {
//   //     console.error("❌ No toProfileId");
//   //     return;
//   //   }

//   //   console.log("🔍 Opening chat with:", toProfileId);

//   //   const conversation = await createConversation(toProfileId);

//   //   if (conversation?._id) {
//   //     const convId = conversation._id;

//   //     setConversationId(convId);
//   //     convIdRef.current = convId;

//   //     const s = getSocket();

//   //     // ✅ Join room only
//   //     s.emit("joinRoom", convId);
//   //     console.log("✅ Joined room:", convId);

//   //     // ✅ Load old messages
//   //     if (Array.isArray(conversation.messages)) {
//   //       setMessages(
//   //         conversation.messages.map((m) => ({
//   //           text: m.text,
//   //           sender: m.isMe ? "me" : "other",
//   //         }))
//   //       );
//   //     } else {
//   //       setMessages([]);
//   //     }
//   //   } else {
//   //     console.error("❌ No conversation ID");
//   //   }
//   // };

// const initConversation = async () => {
//   if (!user) return;

//   const myProfileId = localStorage.getItem("profileId");

//   let toProfileId = null;

//   const loggedUser = JSON.parse(
//     localStorage.getItem("user")
//   );

//   // ✅ FIND OTHER PROFILE
//   if (user.fromProfile?.userId === loggedUser?.id) {
//     toProfileId = user.toProfile?._id;
//   } else {
//     toProfileId = user.fromProfile?._id;
//   }

//   console.log("✅ MY PROFILE:", myProfileId);
//   console.log("✅ OTHER PROFILE:", toProfileId);

//   if (!myProfileId || !toProfileId) {
//     console.error("❌ Missing profile IDs");
//     return;
//   }

//   try {
//     // ✅ CREATE / GET CONVERSATION
//     const conversation = await createConversation(
//       myProfileId,
//       toProfileId
//     );

//     console.log("✅ Conversation:", conversation);

//     if (!conversation?._id) {
//       console.error("❌ No conversation ID");
//       return;
//     }

//     const convId = conversation._id;

//     setConversationId(convId);

//     convIdRef.current = convId;

//     // ✅ JOIN SOCKET ROOM
//     const s = getSocket();

//     s.emit("joinRoom", convId);

//     console.log("✅ Joined room:", convId);

//     // ✅ LOAD OLD MESSAGES
//     const oldMessages = await getMessages(convId);

//     console.log("✅ OLD MESSAGES:", oldMessages);

//     if (Array.isArray(oldMessages)) {
//       setMessages(
//         oldMessages.map((m) => ({
//           text: m.text,

//           sender:
//             String(m.senderId) === String(myProfileId)
//               ? "me"
//               : "other",
//         }))
//       );
//     } else {
//       setMessages([]);
//     }
//   } catch (err) {
//     console.error("❌ initConversation error:", err);
//   }
// };
//   // ✅ SEND MESSAGE (Optimistic UI)
//   const sendMessage = async () => {
//     if (!input.trim() || !conversationId) return;

//     const text = input.trim();
//     setInput("");

//     // ✅ Show instantly
//     setMessages((prev) => [
//       ...prev,
//       { text, sender: "me" },
//     ]);

//     try {
//       setLoading(true);
//       await sendChatMessage(conversationId, text);
//     } catch (err) {
//       console.error("❌ Send failed:", err);

//       // rollback
//       setMessages((prev) => prev.slice(0, -1));
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") sendMessage();
//   };

//   if (!show) return null;

//   const fromProfile = user?.fromProfile || {};
//   const profileURL = fromProfile?.photos?.find(
//     (p) => p.isPrimary
//   );

//   const avatarUrl = profileURL?.url
//     ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${profileURL.url}`
//     : IMG11;

//   return (
//     <div className={`chat-overlay ${isOpen ? "open" : "close"}`}>
//       <div className={`chat-modal ${isOpen ? "slide-up" : "slide-down"}`}>
        
//         {/* HEADER */}
//         <div className="chat-header">
//           <div className="chat-user">
//             <img 
//               src={avatarUrl} 
//               alt="" 
//               onError={(e) => {
//                 e.target.onerror = null;
//                 e.target.src = userAvatar;
//               }}/>
//             <div>
//               <div className="chat-user-name">
//                 {fromProfile?.fullName || user?.name}
//               </div>
//               <div className="chat-user-status">Active now</div>
//             </div>
//           </div>
//           <button onClick={onClose}>✕</button>
//         </div>

//         {/* BODY */}
//         <div className="chat-body" ref={chatBodyRef}>
//           {messages.length === 0 && (
//             <p className="no-messages">
//               Say hi to start the conversation 👋
//             </p>
//           )}

//           {messages.map((msg, i) => (
//             <div
//               key={i}
//               className={`chat-bubble ${
//                 msg.sender === "me" ? "right" : "left"
//               }`}
//             >
//               {msg.text}
//             </div>
//           ))}
//         </div>

//         {/* INPUT */}
//         <div className="chat-input">
//           <input
//             value={input}
//             onChange={(e) => setInput(e.target.value)}
//             onKeyDown={handleKeyDown}
//             placeholder="Type a message..."
//             disabled={!conversationId}
//           />
//           <button
//             onClick={sendMessage}
//             disabled={loading || !conversationId}
//           >
//             {loading ? "..." : "Send"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }


// // ─── Main Component ───────────────────────────────────────────────────────────

// export default function InterestPage() {
//   const [active, setActive] = useState("received");
//   const [animKey, setAnimKey] = useState(0);
//   const [counts, setCounts] = useState();
//   const [receivedInterests, setReceivedInterests] = useState([]);
//   const [sentInterests, setSentInterests] = useState([]);
//   const [acceptedInterests, setAcceptedInterests] = useState([]);
//   const [declinedInterests, setDeclinedInterests] = useState([]);
//   const [toast, setToast] = useState(null);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const interests = useSelector((state) => state.interests.data);

//   useEffect(() => {
//     dispatch(fetchUserInterests());
//   }, [dispatch]);

//   useEffect(() => {
//     const counts = interests?.counts;
//     const tabs = [
//       { key: "received", label: "Received", count: counts?.received || 0 },
//       { key: "sent", label: "Sent", count: counts?.sent || 0 },
//       { key: "accepted", label: "Accepted", count: counts?.accepted || 0 },
//       { key: "declined", label: "Declined", count: counts?.rejected || 0 },
//     ];
//     setCounts(tabs);
//   }, [interests]);

//   useEffect(() => {
//     const data = interests?.data;

//     // ✅ Cache YOUR profileId from interest data
//     if (!localStorage.getItem("profileId")) {
//       let myProfileId = null;

//       if (data?.sent?.length > 0) {
//         myProfileId = data.sent[0]?.fromProfile?._id;
//         console.log("✅ Got profileId from sent:", myProfileId);
//       } else if (data?.received?.length > 0) {
//         myProfileId = data.received[0]?.toProfile?._id;
//         console.log("✅ Got profileId from received:", myProfileId);
//       } else if (data?.accepted?.length > 0) {
//         myProfileId = data.accepted[0]?.toProfile?._id;
//         console.log("✅ Got profileId from accepted:", myProfileId);
//       } else if (data?.rejected?.length > 0) {
//         myProfileId = data.rejected[0]?.toProfile?._id;
//         console.log("✅ Got profileId from rejected:", myProfileId);
//       }

//       if (myProfileId) {
//         localStorage.setItem("profileId", myProfileId);
//         console.log("✅ profileId cached:", myProfileId);
//       } else {
//         console.warn("⚠️ Could not extract profileId from interest data");
//       }
//     }

//     if (data?.received) setReceivedInterests(data.received);
//     if (data?.sent) setSentInterests(data.sent);
//     if (data?.accepted) setAcceptedInterests(data.accepted);
//     if (data?.rejected) setDeclinedInterests(data.rejected);
//   }, [interests]);

//   const handleTabChange = (key) => {
//     if (key !== active) {
//       setActive(key);
//       setAnimKey((prev) => prev + 1);
//     }
//   };

//   const renderSection = ({ acceptRequest, declineRequest }) => {
//     switch (active) {
//       case "received":
//         return (
//           <ReceivedSection
//             received={receivedInterests}
//             acceptRequest={acceptRequest}
//             declineRequest={declineRequest}
//           />
//         );
//       case "sent":
//         return <SentSection sent={sentInterests} />;
//       case "accepted":
//         return <AcceptedSection accepted={acceptedInterests} setToast={setToast} />;
//       case "declined":
//         return <DeclinedSection declined={declinedInterests} />;
//       default:
//         return null;
//     }
//   };

//   const acceptRequest = (id) => {
//     if(id){
//     dispatch(acceptInterest(id));
//     dispatch(fetchUserInterests());
//     }

//   };

//   const declineRequest = (id) => {
//     if(id){
//     dispatch(declineInterest(id));
//     dispatch(fetchUserInterests());
//     }
//   };

//   return (
//     <div className="interest-page">
//       <div className="stats-row1">
//         {counts?.map((tab) => (
//           <div
//             key={tab.key}
//             className={`stat-card ${active === tab.key ? "active" : ""}`}
//             onClick={() => handleTabChange(tab.key)}
//           >
//             <div className="stat-num">{tab.count}</div>
//             <div className="stat-label">{tab.label}</div>
//           </div>
//         ))}
//       </div>

//       <div className="divider" />

//       <div key={animKey}>
//         {renderSection({ acceptRequest, declineRequest })}
//       </div>
//       {toast &&
//        <div className={`toast ${toast.type}`}>{toast.msg}</div>
//       }
//     </div>
//   );
// }


import { useEffect, useRef, useState } from "react";
import "./Interest.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  acceptInterest,
  declineInterest,
  fetchUserInterests,
} from "../redux/interestSlice";

import { useNavigate } from "react-router-dom";

import userAvatar from "../img/user-avatar.png";

import IMG11 from "../img/SSimg1.png";

import {
  createConversation,
  sendChatMessage,
  getMessages,
} from "../services/chatService";

import { io } from "socket.io-client";

// ======================================================
// SOCKET SINGLETON
// ======================================================

let socket = null;

const getSocket = () => {
  if (!socket) {
    socket = io(
      process.env.REACT_APP_SOCKET_URL ||
        "http://localhost:5000",
      {
        transports: ["websocket"],
        auth: {
          token: localStorage.getItem("token"),
        },
      }
    );

    socket.on("connect", () => {
      console.log(
        "🟢 SOCKET CONNECTED:",
        socket.id
      );

      const profileId =
        localStorage.getItem("profileId");

      if (profileId) {
        socket.emit(
          "userOnline",
          profileId
        );
      }
    });

    socket.on("disconnect", () => {
      console.log("🔴 SOCKET DISCONNECTED");
    });
  }

  return socket;
};

// ======================================================
// RECEIVED SECTION
// ======================================================

function ReceivedSection({
  received,
  acceptRequest,
  declineRequest,
}) {
  const navigate = useNavigate();
  const {t} = useTranslation();
  return (
    <div className="content-area">
      <div className="sort-row">
        <span className="section-title">
          {received.length || 0} {t("new_interests")}
        </span>

        <button className="sort-btn">
          {t("sort_by_match")} ↓
        </button>
      </div>

      <div className="received-grid">
        {received.map((p) => {
          const fromProfile =
            p.fromProfile || {};

          const profileURL =
            fromProfile?.photos?.find(
              (photo) =>
                photo.isPrimary
            );

          const imageUrl =
            profileURL?.url
              ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${profileURL.url}`
              : userAvatar;

          const location = [
            fromProfile.location?.city,
            fromProfile.location?.state,
            fromProfile.location
              ?.country,
          ]
            .filter(Boolean)
            .join(", ");

          return (
            <div
              className="interest-card"
              key={p._id}
            >
              <div className="card-top">
                <div className="card-photo-wrap">
                  <img
                    src={imageUrl}
                    alt=""
                    className="card-photo"
                    onError={(e) => {
                      e.target.onerror =
                        null;

                      e.target.src =
                        userAvatar;
                    }}
                  />

                  <span className="interested-badge">
                    Interested in you
                  </span>

                  <span className="match-badge1">
                    {
                      p.matchPercentage
                    }
                    % match
                  </span>
                </div>

                <div className="card-info">
                  <div className="card-time-row">
                    <span className="card-time">
                      {p.timeAgo}
                    </span>
                  </div>

                  <div className="card-name1">
                    {
                      fromProfile.fullName
                    }
                  </div>

                  <div className="card-meta">
                    {fromProfile.age} yrs ·{" "}
                    {location}
                  </div>

                  <div className="card-job">
                    {
                      fromProfile.profession
                    }
                  </div>

                  <div className="card-bio">
                    {fromProfile.aboutMe}
                  </div>
                </div>
              </div>

              <div className="card-actions1">
                <button
                  className="action-btn"
                  onClick={() =>
                    navigate(
                      `/profile/${fromProfile._id}`
                    )
                  }
                >
                  View Profile
                </button>

                <button
                  className="icon-btn1"
                  onClick={() =>
                    acceptRequest(
                      p._id
                    )
                  }
                >
                  ✓
                </button>

                <button
                  className="icon-btn1"
                  onClick={() =>
                    declineRequest(
                      p._id
                    )
                  }
                >
                  ✕
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ======================================================
// SENT SECTION
// ======================================================

function SentSection({ sent }) {
  const {t} = useTranslation();
  return (
    <div className="content-area">
      <div className="section-title">
        {t("interests_sent")}
      </div>

      {sent.length === 0 && (
        <p className="no-connections">
          {t("no_interests_sent")}
        </p>
      )}

      {sent.map((p) => {
        const toProfile =
          p.toProfile || {};

        const profileURL =
          toProfile?.photos?.find(
            (photo) =>
              photo.isPrimary
          );

        const imageUrl =
          profileURL?.url
            ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${profileURL.url}`
            : userAvatar;

        return (
          <div
            className="profile-card1"
            key={p._id}
          >
            <img
              src={imageUrl}
              alt=""
              className="profile-photo"
              onError={(e) => {
                e.target.onerror =
                  null;

                e.target.src =
                  userAvatar;
              }}
            />

            <div className="profile-info">
              <div className="profile-name">
                {toProfile.fullName}
              </div>

              <div className="profile-meta">
                {toProfile.age} yrs
              </div>

              <div className="profile-job">
                {toProfile.profession}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ======================================================
// ACCEPTED SECTION
// ======================================================

function AcceptedSection({
  accepted,
  setToast,
  showToast
}) {
  const [selectedUser, setSelectedUser] =
    useState(null);
const {t} = useTranslation();
  const openChat = (p) => {
    const user = localStorage.getItem("user");
    const userFromStorage = JSON.parse(user);
    // setSelectedUser(p);
    if (userFromStorage?.paymentStatus === "SUCCESS") {
      setSelectedUser(p);
    } else {
      showToast("Please upgrade your plan to message this user.","error");
      // alert("Please complete the payment to start chatting.");
    }
    // setSelectedUser(p);
  };

  return (
    <div className="content-area">
      <div className="section-title2">
        {t("mutual_connections_title")}
      </div>

      {accepted.length === 0 && (
        <p className="no-connections">
          {t("no_accepted_interests")}
        </p>
      )}

      {accepted.map((p) => {
        const user =
          JSON.parse(
            localStorage.getItem(
              "user"
            )
          );

        const userId = user?.id;

        let chatProfile = {};

        if (
          p.fromProfile?.userId ===
          userId
        ) {
          chatProfile =
            p.toProfile || {};
        } else {
          chatProfile =
            p.fromProfile || {};
        }

        const profileURL =
          chatProfile?.photos?.find(
            (photo) =>
              photo.isPrimary
          );

        const imageUrl =
          profileURL?.url
            ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${profileURL.url}`
            : userAvatar;

        return (
          <div
            className="profile-card1"
            key={p._id}
          >
            <img
              src={imageUrl}
              alt=""
              className="profile-photo"
              onError={(e) => {
                e.target.onerror =
                  null;

                e.target.src =
                  userAvatar;
              }}
            />

            <div className="profile-info">
              <div className="profile-name">
                {
                  chatProfile.fullName
                }
              </div>

              <div className="profile-meta">
                {chatProfile.age} yrs
              </div>

              <div className="profile-job">
                {
                  chatProfile.profession
                }
              </div>
            </div>

            <button
              className="action-btn"
              onClick={() =>
                openChat(p)
              }
            >
              Chat
            </button>
          </div>
        );
      })}

      <ChatModal
        isOpen={!!selectedUser}
        user={selectedUser}
        onClose={() =>
          setSelectedUser(null)
        }
      />
    </div>
  );
}

// ======================================================
// DECLINED SECTION
// ======================================================

function DeclinedSection({declined}) {
  const {t} = useTranslation();
    return (
    <div className="content-area">
      <div className="section-title">{t("declined_interests_title")}</div>
      {declined.length === 0 && (
        <p className="no-connections">{t("no_declined_interests")}</p>
      )}
      {declined.map((p) => {
        let user = localStorage.getItem('user');
        let userObj = user ? JSON.parse(user) : null;
        let userId = userObj?.id || null;
        let toProfile = p.toProfile || {};
        if(p.fromProfile?.userId === userId){
          toProfile = p.toProfile || {};
        }

        if(p.toProfile?.userId === userId){
          toProfile = p.fromProfile || {};
        }
        const profileURL = toProfile?.photos?.find(
          (photo) => photo.isPrimary
        );
        const imageUrl = profileURL?.url
          ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${profileURL?.url}`
          : userAvatar || "/default-avatar.png";
        const location = [
          toProfile.location?.city,
          toProfile.location?.state,
          toProfile.location?.country,
        ]
          .filter(Boolean)
          .join(", ");

        return (
          <div className="profile-card1" key={p._id}>
            <img
              src={imageUrl}
              alt={toProfile.fullName || toProfile.firstName + " " + (toProfile.lastName || "")}
              className="profile-photo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = userAvatar;
              }}
            />
            <div className="profile-info">
              <div className="profile-name">{toProfile.fullName || toProfile.firstName + " " + (toProfile.lastName || "")}</div>
              <div className="profile-meta">
                {toProfile.age} yrs · {location}
              </div>
              <div className="profile-job">{toProfile.profession}</div>
              <div className="profile-time">Connected {p.timeAgo}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

// ======================================================
// CHAT MODAL
// ======================================================

function ChatModal({
  isOpen,
  onClose,
  user,
}) {
  const [show, setShow] =
    useState(false);

  const [messages, setMessages] =
    useState([]);

  const [input, setInput] =
    useState("");

  const [conversationId, setConversationId] =
    useState(null);

  const [loading, setLoading] =
    useState(false);

  const chatBodyRef = useRef(null);

  const convIdRef = useRef(null);

  // ======================================================
  // AUTO SCROLL
  // ======================================================

  useEffect(() => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop =
        chatBodyRef.current.scrollHeight;
    }
  }, [messages]);

  // ======================================================
  // OPEN CLOSE
  // ======================================================

  useEffect(() => {
    if (isOpen) {
      setShow(true);

      initConversation();
    } else {
      const s = getSocket();

      if (convIdRef.current) {
        s.emit(
          "leaveRoom",
          convIdRef.current
        );
      }

      setTimeout(() => {
        setShow(false);

        setMessages([]);

        setConversationId(null);

        convIdRef.current = null;
      }, 300);
    }
  }, [isOpen]);

  // ======================================================
  // SOCKET RECEIVE
  // ======================================================

  useEffect(() => {
    if (!conversationId) return;

    const s = getSocket();

    const handleMessage = (
      message
    ) => {
      const myProfileId =
        localStorage.getItem(
          "profileId"
        );

      console.log(
        "📩 SOCKET MESSAGE:",
        message
      );

      // Prevent duplicate
      if (
        String(message.senderId) ===
        String(myProfileId)
      ) {
        return;
      }

      setMessages((prev) => [
        ...prev,
        {
          text: message.text,
          sender: "other",
        },
      ]);
    };

    s.on(
      "receiveMessage",
      handleMessage
    );

    return () => {
      s.off(
        "receiveMessage",
        handleMessage
      );
    };
  }, [conversationId]);

  // ======================================================
  // INIT CONVERSATION
  // ======================================================

  const initConversation =
    async () => {
      try {
        if (!user) return;

        const myProfileId =
          localStorage.getItem(
            "profileId"
          );

        const loggedUser =
          JSON.parse(
            localStorage.getItem(
              "user"
            )
          );

        let toProfileId = null;

        if (
          user.fromProfile
            ?.userId ===
          loggedUser?.id
        ) {
          toProfileId =
            user.toProfile?._id;
        } else {
          toProfileId =
            user.fromProfile?._id;
        }

        const conversation =
          await createConversation(
            myProfileId,
            toProfileId
          );

        if (!conversation?._id)
          return;

        const convId =
          conversation._id;

        setConversationId(convId);

        convIdRef.current =
          convId;

        // JOIN ROOM

        const s = getSocket();

        s.emit("joinRoom", convId);

        console.log(
          "📥 JOINED ROOM:",
          convId
        );

        // LOAD OLD MESSAGES

        const response =
          await getMessages(
            convId
          );

        const oldMessages =
          response || [];

        setMessages(
          oldMessages.map((m) => ({
            text: m.text,

            sender:
              String(m.senderId) ===
              String(myProfileId)
                ? "me"
                : "other",
          }))
        );
      } catch (err) {
        console.log(err);
      }
    };

  // ======================================================
  // SEND MESSAGE
  // ======================================================

  const sendMessage =
    async () => {
      if (
        !input.trim() ||
        !conversationId
      )
        return;

      const text = input.trim();

      setInput("");

      // Optimistic UI

      setMessages((prev) => [
        ...prev,
        {
          text,
          sender: "me",
        },
      ]);

      try {
        setLoading(true);

        await sendChatMessage(
          conversationId,
          text
        );
      } catch (err) {
        console.log(err);

        setMessages((prev) =>
          prev.slice(0, -1)
        );
      } finally {
        setLoading(false);
      }
    };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      sendMessage();
    }
  };

  if (!show || !user)
    return null;

  // ======================================================
  // CHAT PROFILE
  // ======================================================

  const loggedUser = JSON.parse(
    localStorage.getItem("user")
  );

  let chatProfile = {};

  if (
    user.fromProfile?.userId ===
    loggedUser?.id
  ) {
    chatProfile =
      user.toProfile || {};
  } else {
    chatProfile =
      user.fromProfile || {};
  }

  const profileURL =
    chatProfile?.photos?.find(
      (p) => p.isPrimary
    );

  const avatarUrl = profileURL?.url
    ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${profileURL.url}`
    : userAvatar;

  return (
    <div
      className={`chat-overlay ${
        isOpen ? "open" : "close"
      }`}
    >
      <div
        className={`chat-modal ${
          isOpen
            ? "slide-up"
            : "slide-down"
        }`}
      >
        {/* HEADER */}

        <div className="chat-header">
          <div className="chat-user">
            <img
              src={avatarUrl}
              alt=""
              onError={(e) => {
                e.target.onerror =
                  null;

                e.target.src =
                  userAvatar;
              }}
            />

            <div>
              <div className="chat-user-name">
                {chatProfile.fullName}
              </div>

              <div className="chat-user-status">
                Active now
              </div>
            </div>
          </div>

          <button onClick={onClose}>
            ✕
          </button>
        </div>

        {/* BODY */}

        <div
          className="chat-body"
          ref={chatBodyRef}
        >
          {messages.length ===
            0 && (
            <p className="no-messages">
              Say hi 👋
            </p>
          )}

          {messages.map((msg, i) => (
            <div
              key={i}
              className={`chat-bubble ${
                msg.sender === "me"
                  ? "right"
                  : "left"
              }`}
            >
              {msg.text}
            </div>
          ))}
        </div>

        {/* INPUT */}

        <div className="chat-input">
          <input
            value={input}
            onChange={(e) =>
              setInput(
                e.target.value
              )
            }
            onKeyDown={
              handleKeyDown
            }
            placeholder="Type message..."
            disabled={
              !conversationId
            }
          />

          <button
            onClick={sendMessage}
            disabled={
              loading ||
              !conversationId
            }
          >
            {loading
              ? "..."
              : "Send"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ======================================================
// MAIN PAGE
// ======================================================

export default function InterestPage() {
  const {t , i18n} = useTranslation();
  const [active, setActive] =
    useState("received");

  const [animKey, setAnimKey] =
    useState(0);

  const [counts, setCounts] =
    useState([]);

  const [
    receivedInterests,
    setReceivedInterests,
  ] = useState([]);

  const [
    sentInterests,
    setSentInterests,
  ] = useState([]);

  const [
    acceptedInterests,
    setAcceptedInterests,
  ] = useState([]);

  const [
    declinedInterests,
    setDeclinedInterests,
  ] = useState([]);

  const [toast , setToast] = useState(null);
  const dispatch =
    useDispatch();

  const interests =useSelector((state) =>state.interests.data );

  // ======================================================
  // FETCH INTERESTS
  // ======================================================

  useEffect(() => {
    dispatch(fetchUserInterests());
  }, [dispatch]);

  // ======================================================
  // COUNTS
  // ======================================================

  useEffect(() => {
    const counts =
      interests?.counts;

    setCounts([
      {
        key: "received",
        label: t("interests_received"),
        count:
          counts?.received || 0,
      },

      {
        key: "sent",
        label: t("interests_sent"),
        count:
          counts?.sent || 0,
      },

      {
        key: "accepted",
        label: t("interests_accepted"),
        count:
          counts?.accepted || 0,
      },

      {
        key: "declined",
        label: t("interests_declined"),
        count:
          counts?.rejected || 0,
      },
    ]);
  }, [interests, t]);

  // ======================================================
  // DATA
  // ======================================================

  useEffect(() => {
    const data =
      interests?.data;

    if (data?.received)
      setReceivedInterests(
        data.received
      );

    if (data?.sent)
      setSentInterests(
        data.sent
      );

    if (data?.accepted)
      setAcceptedInterests(
        data.accepted
      );

    if (data?.rejected)
      setDeclinedInterests(
        data.rejected
      );
  }, [interests]);

  // ======================================================
  // CACHE PROFILE ID
  // ======================================================

  useEffect(() => {
    if (
      localStorage.getItem(
        "profileId"
      )
    )
      return;

    const user = JSON.parse(
      localStorage.getItem("user")
    );

    const userId = user?.id;

    let myProfileId = null;

    const data =
      interests?.data;

    if (
      data?.accepted?.length >
      0
    ) {
      const item =
        data.accepted[0];

      if (
        item.fromProfile
          ?.userId === userId
      ) {
        myProfileId =
          item.fromProfile._id;
      } else {
        myProfileId =
          item.toProfile._id;
      }
    }

    if (myProfileId) {
      localStorage.setItem(
        "profileId",
        myProfileId
      );

      console.log(
        "✅ PROFILE ID CACHED:",
        myProfileId
      );
    }
  }, [interests, t]);

  // ======================================================
  // TAB CHANGE
  // ======================================================

  const handleTabChange = (
    key
  ) => {
    if (key !== active) {
      setActive(key);

      setAnimKey(
        (prev) => prev + 1
      );
    }
  };

  // ======================================================
  // ACCEPT
  // ======================================================

  const acceptRequest = (id) => {
    dispatch(acceptInterest(id)).unwrap()
    .then((res) => {      
      showToast(res?.message || "Interest accepted!");
    })
    setTimeout(() => {
      dispatch(
        fetchUserInterests()
      );
    }, 500);
  };

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  // ======================================================
  // DECLINE
  // ======================================================

  const declineRequest = (id) => {
    dispatch(declineInterest(id)).unwrap()
    .then((res) => {      
      showToast(res?.message || "Interest declined!", "error");
    })

    setTimeout(() => {
      dispatch(
        fetchUserInterests()
      );
    }, 500);
  };

  // ======================================================
  // RENDER SECTION
  // ======================================================

  const renderSection = () => {
    switch (active) {
      case "received":
        return (
          <ReceivedSection
            received={
              receivedInterests
            }
            acceptRequest={
              acceptRequest
            }
            declineRequest={
              declineRequest
            }
          />
        );

      case "sent":
        return (
          <SentSection
            sent={sentInterests}
          />
        );

      case "accepted":
        return (
          <AcceptedSection
            accepted={
              acceptedInterests
            }
            showToast={showToast}
            setToast={setToast}
          />
        );

      case "declined":
        return (
          <DeclinedSection
            declined={
              declinedInterests
            }
          />
        );

      default:
        return null;
    }
  };

  return (
    <div className="interest-page" data-lang={i18n.language}>
      {/* TABS */}

      <div className="stats-row1">
        {counts.map((tab) => (
          <div
            key={tab.key}
            className={`stat-card ${
              active === tab.key
                ? "active"
                : ""
            }`}
            onClick={() =>
              handleTabChange(
                tab.key
              )
            }
          >
            <div className="stat-num">
              {tab.count}
            </div>

            <div className="stat-label">
              {tab.label}
            </div>
          </div>
        ))}
      </div>

      <div className="divider" />

      {/* CONTENT */}

      <div key={animKey}>
        {renderSection()}
      </div>
      {toast &&
       <div className={`toast ${toast.type}`}>{toast.msg}</div>
      }
    </div>
  );
}